import React from "react"
import PropTypes from "prop-types"

const List = ({
  items,
  children,
  itemRenderer,
  itemDisableActions,
  update,
  ...other
}) => (
  <div className="sh-list">
    {items.map((item, index) => (
      <div className="sh-list--item" key={index}>
        {React.createElement(itemRenderer, {
          ...item,
          ...other,
          index,
          update,
          disableActions: itemDisableActions
        })}
      </div>
    ))}

    {items.length === 0 && children}
  </div>
)

List.propTypes = {
  itemRenderer: PropTypes.func.isRequired,
  itemDisableActions: PropTypes.bool,
  update: PropTypes.func,
  items: PropTypes.array,
  index: PropTypes.index,
  children: PropTypes.node
}

export default List



// WEBPACK FOOTER //
// ./src/components/decorators/List.js